export default {
  data () {
    return {
      isDesktop: window.innerWidth > 997,
      isMobiles: window.innerWidth <= 997,
      windowWidth: window.innerWidth
    }
  },
  created () {
    window.addEventListener('resize', this.changeResolution)

    this.changeResolution()
  },
  beforeDestroy () {
    window.removeEventListener('resize', () => {})
  },
  mounted () {
    this.changeResolution()
  },
  methods: {
    changeResolution () {
      this.isDesktop = window.innerWidth > 997
      this.isMobiles = window.innerWidth <= 997
      this.windowWidth = window.innerWidth
    }
  }
}
